export { default as PrismicLink } from './PrismicLink';
